export const RESOURCES = [
  "ho-so-vi-pham",
  "theo-doi-vi-pham",
  "doi-tuong-vi-pham",
  "trang-chu",
  "user",
  "history-log",
  "phan-quyen",
  "bao-cao",
  "ho-so-ca-nhan",
  "lich-su-thanh-toan"
];

export type Resource = (typeof RESOURCES)[number];

declare const type: readonly ["list", "edit", "detail", "create"];
export type NavigateType = (typeof type)[number];

export enum ResourceType {
  LIST = "danh-sach",
  EDIT = "sua",
  DETAIL = "chi-tiet",
  CREATE = "tao",
  DELETE = "xoa",
}

export const getResourcePath = (
  resource: Resource,
  type: NavigateType,
  id = "id"
) => {
  switch (type) {
    case "list":
      return `/${resource}/${ResourceType.LIST}`;
    case "edit":
      return `/${resource}/${ResourceType.EDIT}/:${id}`;
    case "detail":
      return `/${resource}/${ResourceType.DETAIL}/:${id}`;
    case "create":
      return `/${resource}/${ResourceType.CREATE}`;
    default:
      return "";
  }
};
